import React, { createContext, useContext, useEffect, useState } from 'react';
import { useAllCourses } from '../hooks/V2/useCourse';
import { UICourse } from 'types';

// create a context with a default value of an empty object
const SelectedCourseContext = createContext({
	selectedCourse: {
		value: '',
		label: '',
	},
	assessmentToken: '',
} as {
	selectedCourse: {
		value: string;
		label: string;
		course: { _id: string; tags: string[]; organisation: string };
	};
	setSelectedCourse: React.Dispatch<React.SetStateAction<any>>;
	assessmentToken: string;
	setAssessmentToken: React.Dispatch<React.SetStateAction<any>>;
});

// provide a provider component for the context
export const SelectedCourseProvider = ({ children }: { children: React.ReactNode }) => {
	const { data: allCourses } = useAllCourses();
	const [selectedCourse, setSelectedCourse] = useState({ value: '', label: '', course: { _id: '', tags: [''], organisation: '' } });

	useEffect(() => {
		if (!allCourses) {
			return;
		}
		const formattedData = allCourses
			// @ts-ignore
			?.filter(course => course.isActive)
			.map(course => {
				return {
					label: course.name,
					value: course._id,
					course,
				};
			});
		// add first course with isActive true to selectedCourse
		if (formattedData && formattedData.length > 0) {
			setSelectedCourse(JSON.parse(localStorage.getItem('selectedCourse') || JSON.stringify(formattedData[0])) || formattedData[0]);
		}
	}, [allCourses]);

	const [assessmentToken, setAssessmentToken] = useState('');
	return (
		<SelectedCourseContext.Provider
			value={{
				selectedCourse,
				setSelectedCourse: value => {
					// Set value in local storage
					localStorage.setItem('selectedCourse', JSON.stringify(value));
					setSelectedCourse(value);
				},
				assessmentToken,
				setAssessmentToken,
			}}
		>
			{children}
		</SelectedCourseContext.Provider>
	);
};

// custom hook to use the context
export const useSelectedCourse = () => {
	const context = useContext(SelectedCourseContext);
	if (context === undefined) {
		throw new Error('useSelectedCourse must be used within a SelectedCourseProvider');
	}
	return context;
};
